import type { IBank, IResponseBase } from '@/interfaces';
import type { SelectBaseOption } from 'naive-ui/es/select/src/interface';
import { Http } from './http';
import type { AppSettings } from '@/stores';
import type { ClientResponse } from '@/features/Clients/Client.dto';
import type { IPolicyResult } from '@/interfaces/IPolicyResult';

const http = Http.create();

export class GeneralService {
	static async getBanks() {
		const response = await http.get<IResponseBase<IBank[]>>('/services/banks');
		return response.data;
	}

	static async getEnumItems(enumName: string) {
		const response = await http.get<IResponseBase<SelectBaseOption[]>>(
			`/services/enum/${enumName}`,
		);
		return response.data;
	}

	static async InitilizeSettings() {
		const response = await http.get<AppSettings>(`/services/initialize`);
		return response.data;
	}

	static async updateRenterScore(renterId: string) {
		const response = await http.patch(`/renter/${renterId}/score-update`);
		return response.data;
	}

	static async updateRenterTJ(renterId: string) {
		const response = await http.patch(`/renter/${renterId}/tj-update`);
		return response.data;
	}

	static async sendDocumentSignEmail(renterId: string) {
		const response = await http.post(`/renter/${renterId}/document/resend`);
		return response.data;
	}

	/**
	 * Include renter in Serasa with provided inclusion date
	 */
	static async includeRenterSerasaInclusion(renterId: string, serasaInclusionDate: string) {
		const response = await http.patch<IResponseBase<ClientResponse>>(
			`/renter/${renterId}/serasa-inclusion`,
			{
				id: renterId,
				serasaInclusionDate,
			},
		);
		return response.data.data;
	}

	static async removeRenterSerasaInclusion(renterId: string) {
		const response = await http.delete<IResponseBase<ClientResponse>>(
			`/renter/${renterId}/serasa-inclusion`,
		);

		return response.data.data;
	}

	static async getCasePolicyResult(caseId: string) {
		const response = await http.get<IResponseBase<IPolicyResult>>(`/cases/${caseId}/policy-result`);
		return response.data;
	}
}

export default GeneralService;
